import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { dictionaryInformation } from '../constants/dictionary-information.constant';

export const checkProducts = (statusNumber, products) => {
	if (statusNumber === 100 && products.length > 0) {
		return (
			<>
				<h4>{dictionaryInformation[Enviroment.LANGUAGE].stock}</h4>
				<p>
					Si algunos de los productos solicitados no está en el stock de la farmacia, marca el producto y eliminalo para que no se incluya
					en el link de pago a enviar:
				</p>
			</>
		);
	}
};
